export default __webpack_public_path__ + "static/2previews-8cd81203e1cf0d1182951e38871d3c2e.png";